import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core'

import { UserRoleLoggedVendorUserRoleV1Enum } from '../../../api/api/models/logged-vendor-user-role-v1'
import { LoggedVendorUserV1 } from '../../../api/api/models/logged-vendor-user-v1'
import { RoleTeamMemberRoleV1Enum } from '../../../api/api/models/team-member-role-v1'
import { MenuListItem } from './menu-list-item'
import { MenuRoutes } from './menu-actions'
import { shouldGrant } from '../../auth/auth.service'
import { appVersion } from '../../../../environments/versions'
import { environment } from '../../../../environments/environment'

/**
 * Teams - tabs - readonly for TeamManager, TeamMember
 * create Team - admin
 */

export const allTeamRoles = Object.values(RoleTeamMemberRoleV1Enum)
export const allUserRoles = Object.values(UserRoleLoggedVendorUserRoleV1Enum)

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MenuComponent {

  items: MenuListItem[] = [
    {
      name: 'My Profile',
      value: MenuRoutes.profile,
      imgUrl: '',
      mdIcon: 'account_circle',
      userRoles: allUserRoles,
      teamRoles: allTeamRoles
    },
    {
      name: 'Teams',
      value: MenuRoutes.teams,
      imgUrl: '',
      mdIcon: 'group',
      userRoles: allUserRoles,
      teamRoles: allTeamRoles
    },
    /*
    {
      name: 'Rights',
      value: MenuRoutes.rights,
      imgUrl: '',
      mdIcon: 'folder_shared',
      userRoles: [UserRoleLoggedVendorUserRoleV1Enum.VendorAdmin],
      teamRoles: [RoleTeamMemberRoleV1Enum.TeamAdmin],
      disabled: true,
    },*/
    {
      name: 'Reports',
      value: MenuRoutes.reports,
      imgUrl: '',
      mdIcon: 'insert_chart',
      userRoles: [UserRoleLoggedVendorUserRoleV1Enum.VendorAdmin],
      teamRoles: [RoleTeamMemberRoleV1Enum.TeamAdmin, RoleTeamMemberRoleV1Enum.TeamManager]
    },
    {
      name: 'Log out',
      value: MenuRoutes.logout,
      imgUrl: '',
      mdIcon: 'power_settings_new',
      userRoles: allUserRoles,
      teamRoles: allTeamRoles
    },
  ]

  userVal: LoggedVendorUserV1

  @Input()
  set user(val: LoggedVendorUserV1) {
    this.userVal = val

    if (this.userVal) {
      this.items = this.items
        .filter(item => shouldGrant(this.userVal, item.userRoles, item.teamRoles))
      if (this.items.length === 0) {
        console.error('empty menu, user', this.userVal)
      }
    }

    this.addVersion()
  }

  @Output() onSelected = new EventEmitter<string>()

  onClick(item: MenuListItem) {
    this.onSelected.emit(item.value)
  }


  private addVersion() {
    if (!environment.production) {
      const version = {
        name: `rev: ${appVersion.revision}`,
        imgUrl: '',
        mdIcon: 'flag',
        disabled: true,
        userRoles: [],
        teamRoles: []
      }
      this.items = [...this.items, version]
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/navbar/menu/menu.component.ts